import { render, staticRenderFns } from "./LongTextBubblePartial.vue?vue&type=template&id=fe4aeaaa&scoped=true&"
import script from "./LongTextBubblePartial.vue?vue&type=script&lang=js&"
export * from "./LongTextBubblePartial.vue?vue&type=script&lang=js&"
import style0 from "./LongTextBubblePartial.vue?vue&type=style&index=0&id=fe4aeaaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4aeaaa",
  null
  
)

export default component.exports